import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { CATERING_AGENT_SETTINGS, matchesRouteBase } from '@/services/platformRouting'

export const AI_AGENTS = '/ai/agents'
export const AI_AGENT_GENERAL_SETTINGS = `${AI_AGENTS}/settings`

const CATERING_TABS = [
  { id: 'settings', name: 'Settings', path: '' },
  { id: 'website', name: 'Website leads', path: '/website' }
]

const AI_AGENT_TABS = [
  { id: 'overview', name: 'Overview', path: '' },
  { id: 'manage', name: 'Manage', path: '/settings' }
]

export const agentSettingsPath = (agentId, tab = '') => `${CATERING_AGENT_SETTINGS}/${agentId}${tab}`

export const websiteLeadsPath = agentId => agentSettingsPath(agentId, '/website')

export const websiteReportPath = (agentId, channel) => `${websiteLeadsPath(agentId)}/${channel}/report`

export const isAgentSettingsPath = path => matchesRouteBase(path, CATERING_AGENT_SETTINGS)

export const aiAgentPath = (agentId, tab = '') => `${AI_AGENTS}/${agentId}${tab}`

const routeTabs = (tabs, pathFor, currentPath) =>
  tabs.map(tab => {
    const path = pathFor(tab.path)
    return { id: tab.id, name: tab.name, path, active: currentPath === path }
  })

export const agentSettingsTabs = (agentId, currentPath) =>
  routeTabs(CATERING_TABS, tab => agentSettingsPath(agentId, tab), currentPath)

export const aiAgentTabs = (agentId, currentPath) =>
  routeTabs(AI_AGENT_TABS, tab => aiAgentPath(agentId, tab), currentPath)

// The agent tabs in the shape SecondaryTop's `sections` prop expects, so they
// render and behave like every other tabbed page in the dashboard. These are
// route-backed rather than in-page sections, so `action` navigates and `active`
// comes from the route instead of SecondaryTop's scroll spy.
function useTabSections(tabsFor) {
  const route = useRoute()
  const router = useRouter()

  return computed(() =>
    tabsFor(route.params.id, route.path).map(tab => ({
      id: tab.id,
      name: tab.name,
      active: tab.active,
      action: () => router.push(tab.path)
    }))
  )
}

export const useAgentSections = () => useTabSections(agentSettingsTabs)

export const useAiAgentSections = () => useTabSections(aiAgentTabs)
